import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { useInView } from '../../hooks/useInView';
import { Smartphone, Clock } from '../common/Icon';
import { fonts } from '../../styles/tokens';
import styles from './Download.module.css';

function Download() {
  const { t } = useLang();
  const [ref, visible] = useInView();

  return (
    <section id="download" className={styles.section} ref={ref}>
      <div className={styles.dotPattern} />

      <div
        className={`${styles.content} ${visible ? styles.visible : ''}`}
        style={{ maxWidth: 660, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}
      >
        <h2 style={{ fontFamily: fonts.display, fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 900, color: '#fff', margin: '0 0 14px', lineHeight: 1.15 }}>
          {t.download.heading}
        </h2>
        <p style={{ fontFamily: fonts.body, fontSize: 17, color: 'rgba(255,255,255,0.65)', margin: '0 0 16px', lineHeight: 1.6 }}>
          {t.download.subheading}
        </p>

        {/* Coming soon badge */}
        <div className={styles.comingSoonBadge}>
          <Clock size={15} color="rgba(255,255,255,0.6)" />
          <span>{t.download.comingSoon}</span>
        </div>

        <p style={{ fontFamily: fonts.body, fontSize: 14, color: 'rgba(255,255,255,0.4)', margin: '0 0 36px' }}>
          {t.download.comingSoonNote}
        </p>

        {/* Store buttons — disabled state */}
        <div className={styles.storeRow}>
          {[
            { label: t.download.appStore },
            { label: t.download.playStore },
          ].map((store, i) => (
            <div key={i} className={styles.storeBtn} aria-disabled="true">
              <Smartphone size={22} color="#fff" />
              <div>
                <div style={{ fontFamily: fonts.body, fontSize: 10, color: 'rgba(255,255,255,0.45)', letterSpacing: 0.5 }}>
                  {t.download.comingSoon}
                </div>
                <div style={{ fontFamily: fonts.display, fontSize: 16, fontWeight: 700, color: '#fff' }}>
                  {store.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sign up CTA */}
        <Link to="/signup" className={styles.signUpCta}>
          {t.nav.signUp}
        </Link>
      </div>
    </section>
  );
}

export default Download;
